<template>
  <div>
    <search-list :metaList="metaList" @searchData="search"></search-list>
    <div class="page-wrapper" style="padding-top: 0">
      <Button v-p="{api:'meta/saveMeta'}" type="primary" @click.stop="addN++" class="mb16">新增</Button>
      <table-list
        :columns="columns"
        :data="data"
        :current="current"
        :total="total"
        :loading="loading"
        @change-page="changPage"
      ></table-list>
      <add :n="addN" :metaList="metaList" @done="getList"></add>
      <update :n="updateN" :item="itemData" :metaList="metaList" @done="getList"></update>
    </div>
  </div>
</template>

<script>
  import SearchList from './components/SearchList'
  import TableList from 'components/TableList/index';
  import Add from './components/Add'
  import Update from './components/Update'
  import {allMetaWithExt,metaListByPage,deleteMeta} from "../../../../api/meta";
  import {formatDateTime} from "../../../../utils/format"

  export default {
    name: "metaset",
      components: {
        SearchList,
        TableList,
        Add,
        Update
      },
    created(){
      this.allMetaWithExt()
    },
    data(){
      return {
        itemData:null,
        updateN:0,
        addN:0,
        data: [],
        columns: [
          {
            type: 'index',
            width: 60,
            align: 'center'
          },
          {
            title: ' '
          },
          {
            title: '机构名称 ',
            align: 'center',
            key: 'orgName',
            width: 120,
          },
          {
            title: ' '
          },
          {
            title: '元数据名称 ',
            align: 'center',
            key: 'enumName',
            width: 120,
          },
          {
            title: ' '
          },
          {
            title: '表达式 ',
            align: 'center',
            key: 'enumValueStr',
            width: 320,
            // render:(h,params)=>{
            //   return h('a',{
            //     on:{
            //       click:()=>{
            //         let query = {
            //           fid: params.row['fid'],
            //         };
            //         this.$router.push({name:'personbookinfo',query:query})
            //       }
            //     }
            //   },params.row['fcode'])
            // }
          },
          {
            title: ' '
          },
          {
            title: "创建人",
            align: 'center',
            key: 'createBy',
            width: 120,
          },
          {
            title: ' '
          },
          {
            title: '创建时间',
            align: 'center',
            key: 'createTime',
            width: 160,
            render: (h, params) => {
              return h('span', {}, this.format(params.row['createTime']))
            }
            // render:(h,params)=>{
            //   let maps={'1':'已超期','2':'待支付','3':'待签约','4':'已签约','5':'客户违约','6':'公司违约','7':'已取消' }
            //   return h('span',{},maps[params.row['reservationStatus']+''])
            // }
          },
          {
            title: ' '
          },

          {
            title: '操作',
            align: 'center',
            key: 'action',
            width: 170,
            fixed: 'right',
            render: (h, params) => {
              return h('div', [
                h('a', {
                  style: {
                    // display: params.row.reservationStatus === 2 ?'inline-block' :'none',
                    marginRight: '5px'
                  },
                  directives:[
                    {
                      name:'p',
                      value:{
                        api:'meta/updateMeta'
                      }
                    }
                  ],
                  on:{
                    click: ()=>{
                      this.itemData=params.row
                      this.updateN++
                      // this.isCanCertificate(params)
                    }
                  }
                }, '修改'),
                h('a', {
                directives:[
                  {
                    name:'p',
                    value:{
                      api:'meta/deleteMeta'
                    }
                  }
                ],
                style: {
                  marginRight: '5px',
                  // display: params.row.reservationStatus === 2 ?'inline-block' :'none'
                },
                on: {
                  click: () => {
                    this.$Modal.confirm({
                      title: '删除元数据',
                      content: '<p>确定删除改元数据？</p>',
                      onOk: () => {
                        let params1={
                          metaEnumFid:params.row['metaEnumFid']
                        }
                        deleteMeta(params1).then(res=>{
                          this.$Message.success('操作成功')
                          this.page=1
                          this.current=1
                          this.getList()

                        }).catch(error=>{
                          this.$Message.info('操作失败')})
                      }
                    })
                  }
                }
              }, '删除'),

             ])
            }
          }
        ],
        total: 0,
        current: 1,
        loading: false,
        metaList:[],
        page:1,
        limit:10,
        searchParams:null,

      }
    },
    methods:{
      changPage(n){
        this.current = n;
        this.page = n;
        this.getList()
      },
      search(data){
        this.searchParams=data
        this.page=1
        this.current=1
        this.getList()
      },
      getList(){
        let params={
          ...this.searchParams,
          page:this.page,
          limit:this.limit,
        }
        metaListByPage(params).then(res=>{
          if(!res.data){
            return
          }
          this.total=res.data.total
          res.data.rows&& (this.data=res.data.rows)

        }).catch(error=>{

        })

      },
      allMetaWithExt(){
        allMetaWithExt().then(res=>{
          if(!res.data){
            return
          }
          this.metaList=res.data

        }).catch(error=>{
        })
      },
      format(data) {
        if (!data) {
          return ''
        }
        return formatDateTime(data)
      }
    }
  }
</script>

<style scoped>

</style>
